import { Component, OnInit } from '@angular/core';
import { NgForm,FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
import { SocialAuthService,FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
declare  var jQuery:  any;
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {

	loginRequest: any= {};
	loginError: any;
  	loginForm: any = {};
    fbloginRequest: any= {};
    registersocialRequest: any= {};
    googleloginRequest: any= {};
    registerError: any;
  constructor(
  	public authService: AuthService,
  	private activatedRoute: ActivatedRoute,
    private router: Router,
    private socialAuthService: SocialAuthService,
  ) { }

  ngOnInit() {
  	this.loginRequest = {
      devices_id: new Date().getTime(),
      devices_name: navigator.userAgent,
      app_version: 1,
      devices_type: 'Web',
      login_type: 'Normal',
      os: 'Android10',
      is_signup: 'WP_USER',
      devices_token : 'abceajlkdlfka'
    }
  }
  doLogin(form: NgForm) {
    this.authService.registerSuccess = null;
    if (form.valid) {
      this.loginRequest.email = jQuery("#login_email").val();
      this.loginRequest.password = jQuery("#login_password").val();
      //console.log(this.loginRequest.email);
       //console.log(form.value); 
      let request:any = {
       
      };
      request = Object.assign({}, this.loginRequest);

      this.authService.login(request).then(async (_res) => {

              this.router.navigate(['/clubsponsorship']);

             }).catch((err) => {
              //console.log({ err });
              this.loginError = err;
        });
      }    
  }

  triggersocialsignup(){
    jQuery.magnificPopup.open({
      type: 'inline',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      items: {
            src: jQuery('#signup-social-box')
        },
      fixedContentPos: false,
      callbacks: {
        open: ()=> {
          
        },
        close: ()=> {
          
        }
        // e.t.c.
      }
    });
  }
   // social login function
   public socialSignIn(socialPlatform : string) {
    let socialPlatformProvider;
    //console.log(socialPlatform);
    if(socialPlatform == "facebook"){
      socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    }else if(socialPlatform == "google"){
      socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    }
    if(socialPlatform == "facebook")
    {
      this.socialAuthService.signIn(socialPlatformProvider).then(
        (userData) => {
          this.fbloginRequest.facebook_id = userData.id;
          this.fbloginRequest.device_token = userData.authToken;
           this.fbloginRequest.email = userData.email;
          let request:any = {
      
          };
          request = Object.assign({}, this.fbloginRequest);
          //console.log(request);
          this.authService.sociallogin(request).then(async (_res) => {
            let params = this.activatedRoute.snapshot.queryParams;
            //console.log(params);
            if (params.redirect){
              this.router.navigate([params.redirect]);
            }else{
              jQuery('.popup-login').magnificPopup('close');
             
            }
            //console.log("trybox");
          })
          .catch((err) => {
              //console.log("catchbox");
              //console.log({ err });
              if(err.status == 2)
              {
                this.registersocialRequest = {
                  devices_id: new Date().getTime(),
                  devices_name: navigator.userAgent,
                  app_version: 1,
                  devices_type: 'Web',
                  login_type: 'Facebook',
                  phone_code: 91,
                  facebook_id: userData.id,
                  first_name: userData.firstName,
                  last_name: userData.lastName,
                  email: userData.email
                };
                console.log("this shoud run");
                /*jQuery('.popup-login').magnificPopup('close');*/
                this.triggersocialsignup();
                /*jQuery("#signup-trigger").click();*/
              }else{
                this.registerError = err.message;
              }
            });
            //console.log(socialPlatform+" sign in data : " , userData);
        }
      );
    }else if(socialPlatform == "google"){
      this.socialAuthService.signIn(socialPlatformProvider).then(
        (userData) => {
          this.googleloginRequest.login_type = 'Google';
          this.googleloginRequest.google_id = userData.id;
          this.googleloginRequest.device_token = userData.authToken;
           this.googleloginRequest.email = userData.email;
          let request:any = {
      
          };
          request = Object.assign({}, this.googleloginRequest);
          //console.log(request);
          this.authService.sociallogin(request).then(async (_res) => {
            let params = this.activatedRoute.snapshot.queryParams;
            //console.log(params);
            if (params.redirect){
              this.router.navigate([params.redirect]);
            }else{
              jQuery('.popup-login').magnificPopup('close');
              
            }
            //console.log("trybox");
          })
          .catch((err) => {
              //console.log("catchbox");
              //console.log({ err });
              if(err.status == 2)
              {
                this.registersocialRequest = {
                  devices_id: new Date().getTime(),
                  devices_name: navigator.userAgent,
                  app_version: 1,
                  devices_type: 'Web',
                  login_type: 'Google',
                  phone_code: 91,
                  google_id: userData.id,
                  first_name: userData.firstName,
                  last_name: userData.lastName,
                  email: userData.email
                };
                //jQuery("#signup-trigger").click();
                this.triggersocialsignup();
              }else{
                this.registerError = err.message;
              }
            });
            //console.log(socialPlatform+" sign in data : " , userData);
        }
      );
    }
  }

}
